import $ from 'jquery';

const { __ } = wp.i18n;

/**
 * The accordion logic for the content filters.
 */
const initFilterAccordion = () => {
	const filtersTitle = $('.em-filterable-content__title');
	const inputs = $('.em-filterable-content__filters input');
	const listTitle = $('.em-filterable-content__list-title');

	listTitle.click(function () {
		const accordion = $(this).next('ul');
		accordion.slideToggle('slow');
		$(this).toggleClass('active');
	});

	inputs.click(function () {
		const filters = $(this).parents('.em-filterable-content__accordion');
		filters.addClass('active');
		filtersTitle.addClass('active');
		filters.slideDown('slow');
	});

	if (filtersTitle.length > 0) {
		filtersTitle.click(function () {
			const filters = $(this).parent().find('.em-filterable-content__accordion');
			$(this).toggleClass('active');
			$('.em-filterable-content__accordion').toggleClass('active');
			filters.slideToggle('slow');

			const isSupport = $(this).parent().hasClass('em-filterable-content__footer');
			if ($(this).hasClass('active') && isSupport) {
				$(this).find('span').text(__('Show Less Filters', 'embark'));
			} else {
				$(this).find('span').text(__('Show More Filters', 'embark'));
			}
		});
	}

	$('#document-orderby').change(function () {
		const text = $(this).find('option:selected').text();
		const $aux = $('<select/>').append($('<option/>').text(text));
		$(this).after($aux);
		$(this).width($aux.width());
		$aux.remove();
	}).change();

	$(document).click((e) => {
		const el = e.target;
		const closest = el.closest('.em-filterable-content__filter-container') || el.closest('.em-filterable-content__active-filters');
		if (!closest) {
			const trigger = $('.em-filterable-content__title');

			if (trigger.hasClass('active')) {
				trigger.click();
			}
		}
	});
};

export default initFilterAccordion;
